// src/config.js
// Google OAuth configuration

export const googleConfig = {
  clientId: '349327078403-re2rvk6sp15gqivkkhc0ma6554tn3chn.apps.googleusercontent.com'
};